// Entry and timer rules shared by the server and the client (architecture sprint-03 §3.5).
// Dependency-free constants only.

/** 24h: the total before the split (manual) and the cap per saved part (timer). */
export const MAX_ENTRY_SECONDS = 86_400;
/** Timer parts and totals under 1 minute are not saved. */
export const MIN_TIMER_PART_SECONDS = 60;
/** 09:00, the form Start when the day has no usable latest end. */
export const DEFAULT_START_SECOND = 9 * 3600;
/** 0:30. */
export const DEFAULT_DURATION_SECONDS = 30 * 60;
export const MAX_DESCRIPTION_LENGTH = 500;
export const MIN_ENTRY_DATE = '2000-01-01';
export const MAX_ENTRY_DATE = '2099-12-31';
/** GET /api/entries: to minus from must be under this many days. */
export const MAX_LIST_RANGE_DAYS = 62;
export const SUGGESTION_WINDOW_DAYS = 365;
export const SUGGESTION_LIMIT = 8;
export const SUGGESTION_HALF_LIFE_HOURS = 72;
export const SWITCH_PRESET_MINUTES = [0, 5, 15, 30] as const;
